import { createRouter } from "@tanstack/react-router";
import { queryClient } from "@/lib/api/queryClient";
import { parseSearch, stringifySearch } from "@/lib/searchParams";
import { routeTree } from "./routeTree.gen";

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
  // Keep ids as strings (the default parser turns 10-digit tenant ids into numbers).
  parseSearch,
  stringifySearch,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
